import { CellProps } from 'react-table';
import AutocompleteV2 from '../../../../component/AutocompleteObjectV2';
import EditableCell from './EditableCell';

const ObjectTypeCell = ({ row, tableOptions }: CellProps<any>) => {
	const { updateRowData, listDoiTuong } = tableOptions;
	const rowData = row.original;

	return (
		<EditableCell
			editComponent={({ setEnableEditing }: any) => {
				return (
					<AutocompleteV2
						autoFocus
						options={listDoiTuong || []}
						value={rowData?.visitObjectType}
						name="visitObjectType"
						onChange={(selectedOption) => {
							updateRowData(row.index, (value: any) => ({
								...value,
								visitObjectType: selectedOption,
							}));
							setEnableEditing(false);
						}}
                        onBlur={() => {
							setEnableEditing(false);
						}}
						className="autocomplete-custom-tiep-nhan radius spaces width-100 h-25"
						isClearable={false}
					/>
				);
			}}
			textValue={rowData?.visitObjectType?.name}
		/>
	);
};

export default ObjectTypeCell;
